import { render, staticRenderFns } from "./AdminGame.vue?vue&type=template&id=1fa021d8&scoped=true&"
import script from "./AdminGame.vue?vue&type=script&lang=js&"
export * from "./AdminGame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa021d8",
  null
  
)

export default component.exports